import { type StateCreator } from 'zustand';

export interface MerchantRoleAccessResponse {
  code: number;
  data: MerchantRoleAccess;
  message: string;
  status: string;
}

export interface MerchantRoleAccess {
  access: GroupAccess[];
  action: Record<string, boolean>;
}

export interface GroupAccess {
  group: string;
  order: number;
  role_access: RoleAccess[];
}

export interface RoleAccess {
  name: string;
  route: string;
  action?: string[];
  order: number;
}

export type MerchantRoleAccessSlice = {
  merchantAccess: MerchantRoleAccess | null;
  setMerchantAccess: (merchantAccess: MerchantRoleAccess) => void;
};

export const createMerchantRoleAccessSlice: StateCreator<
  MerchantRoleAccessSlice,
  [],
  [],
  MerchantRoleAccessSlice
> = (set) => ({
  merchantAccess: null,
  setMerchantAccess: (merchantAccess) => set({ merchantAccess }),
});
